<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M7 6.25C7 7.07843 6.32843 7.75 5.5 7.75C4.67157 7.75 4 7.07843 4 6.25C4 5.42157 4.67157 4.75 5.5 4.75C6.32843 4.75 7 5.42157 7 6.25Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M7 13.75C7 14.5784 6.32843 15.25 5.5 15.25C4.67157 15.25 4 14.5784 4 13.75C4 12.9216 4.67157 12.25 5.5 12.25C6.32843 12.25 7 12.9216 7 13.75Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M10.75 13.75H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M10.75 6.25H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: 'BulletTextIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>